import { CallStatuses, CallTypes } from '@entities/call';
import type { RingIncomingCallUsecase } from '@usecases/ring-incoming-call.usecase';
import type { BaseController } from '@infra/controllers/base.controller';
import type { RingIncomingCallRequest } from '@usecases/ring-incoming-call.usecase';
import { InvalidRingIncomingCallRequest } from '@usecases/ring-incoming-call.usecase';
import uuid from '@main/utils/uuid';

export type RingIncomingCallInput = {
  from: string;
  to?: string;
  callUuid?: string;
  type?: string;
};

export type RingIncomingCallOutput = InvalidRingIncomingCallRequest | void;

export class RingIncomingCallController
  implements BaseController<RingIncomingCallInput, RingIncomingCallOutput>
{
  constructor(private usecase: RingIncomingCallUsecase) {}

  async handle(req: RingIncomingCallInput): Promise<RingIncomingCallOutput> {
    const callid = !req.callUuid
      ? uuid()
      : req.type === 'rollback-transfer'
      ? req.callUuid + '_Rollback' + uuid()
      : req.callUuid;
    // Use a random number if 'to' is missing to test validation
    const toNumber = req.to || req.from;

    const usecaseRequest: RingIncomingCallRequest = {
      id: callid,
      from: `+${req.from}`,
      to: toNumber,
      status: CallStatuses.RINGING,
      type: CallTypes.INBOUND,
    };

    try {
      await this.usecase.run(usecaseRequest);
    } catch (error) {
      if (error instanceof InvalidRingIncomingCallRequest) {
        return error;
      }
      throw error;
    }
  }
}
